import StyledLink from '../Link.mjs';
import styled from 'styled-components';

const StyledTextLink = styled(StyledLink) `
  transition: ${props => props.theme.animation.duration.quick1}
    ${props => props.theme.animation.easing.productive.standard} all;
  text-decoration: ${props => (props.underlined ? 'underline' : 'none')};
  text-decoration-color: ${props => props.theme.colors.textColor}00;

  @media (pointer: fine) {
    &:hover {
      color: ${props => (props.hoverColor ? props.hoverColor : props.theme.colors.textColor)};
      text-decoration-color: ${props => props.hoverColor ? props.hoverColor : props.theme.colors.textColor};
    }
  }
`;

export { StyledTextLink };
//# sourceMappingURL=TextLink.styles.mjs.map
